export enum FinancialChannelType {
    None = 'None', 
    Cash = 'Cash', 
    BankAccount = 'BankAccount', 
    BankCard = 'BankCard', 
    DigitalPayment = 'DigitalPayment', 
    LuPid = 'LuPid', 
    LuTp = 'LuTp', 
    LuTpSocial = 'LuTpSocial', 
    Cancelled = 'Cancelled'
}

export enum IncomeDirection {
    Income = 'Income', 
    Expense = 'Expense'
}